module.exports = __webpack_public_path__ + "static/img/bg8.45c8510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/bg8.jpg
// module id = QhAp
// module chunks = 155